<template>
  <div class="container mx-auto w-full h-full bg-gray-200">
    <div class="overflow-hidden relative p-10 h-full wrap">
      <div class="absolute h-full border border-gray-700 border-opacity-20 border-2-2" style="left: 50%" />
      <div class="flex justify-between items-end mb-8 w-full">
        <span>
          <h3 class="mb-3 text-xl font-bold text-black">Mahasiswa</h3>
        </span>
        <span>
          <h3 class="mb-3 text-xl font-bold text-black">Admin</h3>
        </span>
      </div>

      <!-- right timeline : validasi dokumen KRS/KHS -->
      <div class="flex justify-between items-center mb-8 w-full right-timeline" v-if="latestStudentReport">
        <div class="order-1 w-5/12" />
        <div class="flex z-20 order-1 items-center w-8 h-8 bg-gray-800 rounded-full shadow-xl">
          <h1 class="mx-auto text-lg font-semibold text-white" />
        </div>
        <div class="order-1 py-4 px-6 w-5/12 bg-gray-400 rounded-lg shadow-xl border-black border-4">
          <h3 class="mb-3 text-xl font-bold text-white">
            PERIODE : {{ scholarshipPeriod }} {{ scholarshipYear }}
          </h3>
          <ul class="list-disc">
            <!-- Semester -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              Semester: {{ latestStudentReport.school_semester }}
            </li>

            <!-- KRS -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KRS:
              {{ getVerifiedStatus("krs_file_verified", "studentReport") }}
              <i
                v-if="latestStudentReport.krs_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="latestStudentReport.krs_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              latestStudentReport.krs_file_reason
            }}</span>

            <!-- KHS -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KHS:
              {{ getVerifiedStatus("khs_file_verified", "studentReport") }}
              <i
                v-if="latestStudentReport.khs_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="latestStudentReport.khs_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              latestStudentReport.khs_file_reason
            }}</span>

            <!-- Persetujuan Pembayaran -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              Persetujuan Pembayaran: {{ latestStudentReport.approval_status }}
              <i
                v-if="latestStudentReport.approval_status_payment_id === 5"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="latestStudentReport.approval_status_payment_id === 4"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>

            <!-- Status Pembayaran -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              Status Pembayaran: {{ latestStudentReport.payment_status }}
            </li>

            <!-- Keterangan Pembayaran -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              Keterangan: {{ latestStudentReport.payment_status_reason }}
            </li>

            <!-- Timestamps -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              Timestamps: {{ latestStudentReport.timestamps }}
            </li>

            <inertia-link
              as="button"
              class="btn-indigo mt-2"
              :href="route('mahasiswa.krs.index')">
              Lihat KRS/KHS
            </inertia-link>
            <inertia-link
              as="button"
              class="btn-indigo mt-2"
              :href="route('mahasiswa.payment_info.index')"
              v-if="latestStudentReport.approval_status_payment_id === 4">
              Lihat Bukti Pembayaran
            </inertia-link>
          </ul>
        </div>
      </div>

      <!-- left timeline : BELUM UPLOAD KRS PERIODE INI -->
      <div class="flex flex-row-reverse justify-between items-center mb-8 w-full left-timeline" v-else>
        <div class="order-1 w-5/12" />
        <div class="flex z-20 order-1 items-center w-8 h-8 bg-gray-800 rounded-full shadow-xl">
          <h1 class="mx-auto text-lg font-semibold text-white" />
        </div>
        <div class="order-1 py-4 px-6 w-5/12 bg-red-400 rounded-lg shadow-xl border-black border-4">
          <h3 class="mb-3 text-xl font-bold text-white">
            PERIODE : {{ scholarshipPeriod }} {{ scholarshipYear }}
          </h3>
          <p class="text-sm font-medium tracking-wide leading-snug text-white text-opacity-100">
            Silahkan Unggah Data KRS KHS.
            <inertia-link
              as="button"
              class="btn-indigo mt-2"
              :href="route('mahasiswa.krs.index')">
              Klik Disini Untuk Unggah KRS/KHS
            </inertia-link>
          </p>
        </div>
      </div>

      <!-- left timeline : DITERIMA -->
      <div class="flex flex-row-reverse justify-between items-center mb-8 w-full left-timeline">
        <div class="order-1 w-5/12" />
        <div class="flex z-20 order-1 items-center w-8 h-8 bg-gray-800 rounded-full shadow-xl">
          <h1 class="mx-auto text-lg font-semibold text-white">
            2
          </h1>
        </div>
        <div class="order-1 py-4 px-6 w-5/12 bg-green-400 rounded-lg shadow-xl">
          <h3 class="mb-3 text-xl font-bold text-white">
            BIODATA : {{ statusList[2].name }}
          </h3>
          <p class="text-sm font-medium tracking-wide leading-snug text-white text-opacity-100">
            Berkas memenuhi syarat.
          </p>
        </div>
      </div>
      <!-- right timeline : Biodata info -->
      <div class="flex justify-between items-center mb-8 w-full right-timeline">
        <div class="order-1 w-5/12" />
        <div class="flex z-20 order-1 items-center w-8 h-8 bg-gray-800 rounded-full shadow-xl">
          <h1 class="mx-auto text-lg font-semibold text-white">
            1
          </h1>
        </div>
        <div
          class="order-1 py-4 px-6 w-5/12 bg-gray-400 rounded-lg shadow-xl"
          :class="statusList[1].id === statusCurrent.id &&
            'border-black border-4'
          ">
          <h3 class="mb-3 text-xl font-bold text-white">
            Biodata sudah terverifikasi
          </h3>
          <ul class="list-disc">
            <!--KTP -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KTP: {{ getVerifiedStatus("nik_file_verified") }}
              <i
                v-if="mahasiswa.nik_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.nik_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.nik_file_reason
            }}</span>

            <!-- KTM -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KTM:
              {{ getVerifiedStatus("student_id_file_verified") }}
              <i
                v-if="mahasiswa.student_id_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.student_id_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.student_id_file_reason
            }}</span>

            <!-- KK -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KK: {{ getVerifiedStatus("no_kk_file_verified") }}
              <i
                v-if="mahasiswa.no_kk_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.no_kk_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.no_kk_file_reason
            }}</span>

            <!-- PHOTO -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              Photo: {{ getVerifiedStatus("photo_verified") }}
              <i
                v-if="mahasiswa.photo_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.photo_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.photo_reason
            }}</span>

            <!-- Buku Rekening -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              Buku Rekening:
              {{ getVerifiedStatus("bank_acc_file_verified") }}
              <i
                v-if="mahasiswa.bank_acc_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.bank_acc_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.bank_acc_file_reason
            }}</span>

            <!-- KTP Ayah -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KTP Ayah:
              {{ getVerifiedStatus("father_nik_file_verified") }}
              <i
                v-if="mahasiswa.father_nik_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.father_nik_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.father_nik_file_reason
            }}</span>

            <!-- KTP Ibu -->
            <li class="tracking-wide leading-snug text-white text-opacity-100">
              KTP Ibu:
              {{ getVerifiedStatus("mother_nik_file_verified") }}
              <i
                v-if="mahasiswa.mother_nik_file_verified === 0"
                class="fas fa-times-circle"
                style="color: firebrick" />
              <i
                v-if="mahasiswa.mother_nik_file_verified === 1"
                class="fas fa-check-circle"
                style="color: forestgreen" />
            </li>
            <span class="text-sm">{{
              mahasiswa.mother_nik_file_reasonF
            }}</span>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue2'
const VERIFIED_STATS = {
    null: 'SEDANG DIVERIFIKASI',
    0: 'DITOLAK',
    1: 'DITERIMA',
}
export default {
    props: {
        statusList: Array,
        statusCurrent: Object,
        mahasiswa: Object,
        pivotStudentEducationId: Number,
        latestStudentReport: Object,
    },
    components: {
        'inertia-link': Link,
    },
    computed: {
        scholarshipPeriod () {
            return this.$page.props.scholarship_period
        },
        scholarshipYear () {
            return this.$page.props.scholarship_year
        },
    },
    methods: {
        getVerifiedStatus (fieldName, objType = 'mahasiswa') {
            if (objType === 'mahasiswa')
                return VERIFIED_STATS[this.mahasiswa[fieldName]]
            if (objType === 'studentReport')
                return VERIFIED_STATS[this.latestStudentReport[fieldName]]
        },
    },
}
</script>
